import MergeLeadsModal from './MergeLeadsModal';
export default MergeLeadsModal;
